import { IconNames } from '@blueprintjs/icons';
import { ActionButtonText, Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { PhoneInputFormik, TextInputFormik } from '@strata/react-inputs';
import { SuccessToast } from '@strata/react-toast-message';
import { FieldArray } from 'formik';
import { useState } from 'react';

import { EMPTY_ADDITIONAL_OPS_CONTACT } from 'services/NPISupport';

export const AdditionalOpsContactsFields = () => {
    const [indexToRemove, setIndexToRemove] = useState(undefined);

    return (
        <FieldArray name="additional_ops_contacts">
            {(arrayHelpers) => {
                const contacts = arrayHelpers.form.values.additional_ops_contacts || [];
                return (
                    <>
                        {contacts.map((contact, index) => {
                            const contactNumber = index + 1;
                            const prefix = `Additional Ops Contact ${contactNumber}`;
                            const fieldPrefix = `${arrayHelpers.name}.${index}`;
                            return (
                                <div
                                    key={contact.supplier_contact_id || index}
                                    className="margin__top--large"
                                >
                                    <div
                                        className="flex__gap--small margin__bottom--medium"
                                        style={{
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <span className="font-regular--uppercase">{prefix}</span>
                                        <ActionButtonText
                                            label="Remove Contact"
                                            onClick={() => setIndexToRemove(index)}
                                        />
                                    </div>
                                    <TextInputFormik
                                        label={`${prefix} First Name`}
                                        id={`${fieldPrefix}.first_name`}
                                    />
                                    <TextInputFormik
                                        label={`${prefix} Last Name`}
                                        id={`${fieldPrefix}.last_name`}
                                    />
                                    <TextInputFormik
                                        label={`${prefix} Email`}
                                        id={`${fieldPrefix}.email`}
                                    />
                                    <PhoneInputFormik
                                        allowExtension
                                        label={`${prefix} Phone`}
                                        id={`${fieldPrefix}.phone`}
                                    />
                                </div>
                            );
                        })}
                        <ActionButtonText
                            className="margin__bottom--large"
                            label="Add Ops Contact"
                            leftIcon={IconNames.ADD}
                            onClick={() => arrayHelpers.push({ ...EMPTY_ADDITIONAL_OPS_CONTACT })}
                        />
                        <WarningDialog
                            dialogTitle="Remove Contact"
                            isOpen={indexToRemove != null}
                            primaryButtonLabel="Remove"
                            primaryButtonIntent={Button.Intent.DANGER}
                            secondaryButtonLabel="Cancel"
                            onPrimaryButtonClick={() => {
                                arrayHelpers.remove(indexToRemove);
                                setIndexToRemove(undefined);
                                SuccessToast({
                                    message: 'Contact has been successfully removed.',
                                });
                            }}
                            onSecondaryButtonClick={() => setIndexToRemove(undefined)}
                            dialogContent="Are you sure you want to remove this contact?"
                        />
                    </>
                );
            }}
        </FieldArray>
    );
};
